const parseQueryParamToSafeInteger = (value) => {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  if (!/^-?\d+$/.test(trimmed)) return null;
  const numberValue = Number(trimmed);
  if (!Number.isSafeInteger(numberValue)) return null;
  return numberValue;
};

export default parseQueryParamToSafeInteger;
